import React, { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import client from '../api/client';

const BASE_ROLE_LINKS = {
  client:    [{ to: '/dashboard', label: 'Dashboard' }],
  annotator: [{ to: '/work',      label: 'Work Queue' }],
  reviewer:  [{ to: '/review',    label: 'Review Queue' }],
  admin:     [
    { to: '/admin',               label: 'Admin Overview' },
    { to: '/admin/demo-requests', label: 'Demo Requests', badge: true },
    { to: '/dashboard',           label: 'Dashboard' },
    { to: '/work',                label: 'Work Queue' },
    { to: '/review',              label: 'Review Queue' },
  ],
};

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const links = BASE_ROLE_LINKS[user?.role] || [];
  const [uncontactedCount, setUncontactedCount] = useState(0);

  useEffect(() => {
    if (user?.role !== 'admin') return;
    client.get('/api/admin/demo-requests/')
      .then((res) => {
        setUncontactedCount(res.data.filter((r) => !r.contacted).length);
      })
      .catch(() => {});
  }, [user]);

  function handleLogout() {
    logout();
    navigate('/login');
  }

  return (
    <nav style={styles.nav}>
      <span style={styles.brand}>AINA</span>

      <div style={styles.links}>
        {links.map(({ to, label, badge }) => (
          <NavLink
            key={to}
            to={to}
            style={({ isActive }) => ({
              ...styles.link,
              ...(isActive ? styles.linkActive : {}),
            })}
          >
            {label}
            {badge && uncontactedCount > 0 && (
              <span style={styles.badgeCount}>{uncontactedCount}</span>
            )}
          </NavLink>
        ))}
      </div>

      <div style={styles.user}>
        <span style={styles.userName}>{user?.name}</span>
        <span style={styles.role}>{user?.role}</span>
        <button onClick={handleLogout} style={styles.logoutBtn}>Logout</button>
      </div>
    </nav>
  );
}

const styles = {
  nav: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 1.5rem',
    height: '56px',
    background: '#000',
    color: '#fff',
    borderBottom: '1px solid #222',
  },
  brand: {
    fontWeight: 800,
    fontSize: '1.2rem',
    letterSpacing: '0.1em',
    color: '#fff',
  },
  links: {
    display: 'flex',
    gap: '0.1rem',
  },
  link: {
    color: '#999',
    textDecoration: 'none',
    padding: '0.4rem 0.85rem',
    fontSize: '0.88rem',
    display: 'flex',
    alignItems: 'center',
    gap: '0.4rem',
    letterSpacing: '0.02em',
  },
  linkActive: {
    color: '#fff',
    background: 'rgba(255,255,255,0.1)',
  },
  badgeCount: {
    background: '#b8c5d1',
    color: '#000',
    fontSize: '0.68rem',
    fontWeight: 700,
    padding: '0.1rem 0.4rem',
    minWidth: '18px',
    textAlign: 'center',
    lineHeight: '1.4',
  },
  user: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
  },
  userName: {
    fontSize: '0.88rem',
    fontWeight: 600,
    color: '#fff',
  },
  role: {
    fontSize: '0.72rem',
    background: 'rgba(255,255,255,0.12)',
    padding: '0.2rem 0.5rem',
    textTransform: 'capitalize',
    color: '#ccc',
    letterSpacing: '0.04em',
  },
  logoutBtn: {
    background: 'rgba(255,255,255,0.08)',
    color: '#ccc',
    border: '1px solid #444',
    padding: '0.3rem 0.75rem',
    cursor: 'pointer',
    fontSize: '0.82rem',
  },
};
